const {Component} = require("react");
const {observer} = require("mobx-react");
const store = require("stores/UserStore");
const router = require("services/router");
const PropTypes = require("prop-types");
const Loader = require("components/mixins/Loader");
const BeforeUnload = require("helpers/BeforeUnload");

@observer
class Avatar extends Component {

	static get propTypes() {
		return {
			defaultUrl: PropTypes.string
		};
	}

	static get defaultProps() {
		return {
			defaultUrl: "img/avatar.png"
		}

	}

	constructor(props) {
		super(props);

		this.state = {
			loading: false,
			errors: null,
		};
	}

	get className() {
		let classList = ["avatar", "avatar-backend", "img"];

		if (this.state.loading) {
			classList.push("loading");
		}

		return classList.join(" ");
	}

	get url() {
		return store.get("avatar.url", router.url(this.props.defaultUrl));
	}

	componentDidMount() {
		this.input.addEventListener("change", () => {
			if (this.input.files.length > 0) {
				this.setState({loading: true});

				const data = new FormData();
				data.append("avatar", this.input.files[0]);

				store
					.save(data, {
						headers: {
							"Content-Type": "multipart/form-data"
						}
					})
					.then(() => {
						this.setState({loading: false, errors: null});
						BeforeUnload.clear();
					})
					.catch(xhr => {
						let state = {loading: false};

						if (xhr && xhr.response && xhr.response.data && xhr.response.data.errors) {
							state.errors = xhr.response.data.errors;
						}

						this.setState(state);
					});
			}
		});
	}

	renderErrors() {
		if (!this.state.errors || Object.keys(this.state.errors).length < 1) return null;

		const errors = Object.keys(this.state.errors).map((err, index) => (
			<p key={index} className="error">{this.state.errors[err][0]}</p>
		));

		return (
			<React.Fragment>
				{errors}
			</React.Fragment>
		);
	}

	render() {
		return (
			<div className={this.className}>
				<img src={this.url} alt="avatar"/>
				<Loader active={this.state.loading}/>
				<input id="avatarFileInput" type="file" ref={el => this.input = el} accept="image/*"/>
				<label htmlFor="avatarFileInput" className="update-image">Opdater profilbillede</label>
				{this.renderErrors()}
			</div>
		);
	}

}

module.exports = Avatar;



// WEBPACK FOOTER //
// ./resources/js/components/backend/Avatar.js